module.exports = __webpack_public_path__ + "img/yom-hatzmaut-2020-thumbnail.a0b897a5.jpg";